import { NUMBER, INTEGER, DATE, TIME, DATETIME } from '@/plugins/sdk/fields'
import isFinite from 'lodash/isFinite'
import isString from 'lodash/isString'
import isDate from 'lodash/isDate'

export default {
  label: 'Is greater than',
  operator: 'is greater than',
  fields: [ NUMBER, INTEGER, DATE, TIME, DATETIME ],
  isValidValue (value) {
    return isDate(value) || isFinite(value) || (isString(value) && value.length)
  }
}
